module.exports = __webpack_public_path__ + "img/charging-hub-definitive-semipublic.844286d7.svg";